<template>
  <div v-if="mute">
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
      <g id="그룹_16377" data-name="그룹 16377" transform="translate(-40 -183)">
        <g id="그룹_14946" data-name="그룹 14946" transform="translate(-248 92)">
          <circle id="타원_436" data-name="타원 436" cx="20" cy="20" r="20" transform="translate(288 91)" fill="#f5f5f5"/>
        </g>
        <g id="mute" transform="translate(43.429 188)">
          <path id="패스_1017" data-name="패스 1017" d="M18,10l5.714,5.714m-5.714,0L23.714,10" transform="translate(6.429 2.143)" fill="none" stroke="#7260ff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
          <path id="패스_1018" data-name="패스 1018" d="M17.286,5V25l-7.143-5.714H3V10.714h7.143Z" transform="translate(0 0)" fill="#7260ff" stroke="#7260ff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
          <path id="패스_1019" data-name="패스 1019" d="M13,15.714a3.52,3.52,0,0,0,1.58-3.277A3.31,3.31,0,0,0,13,10" transform="translate(4.286 2.143)" fill="none" stroke="#7260ff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
        </g>
      </g>
    </svg>
  </div>
  <div v-else>
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
      <g id="그룹_16826" data-name="그룹 16826" transform="translate(-40 -124)">
        <circle id="타원_436" data-name="타원 436" cx="20" cy="20" r="20" transform="translate(40 124)" fill="#f5f5f5"/>
        <g id="mute" transform="translate(48 129)">
          <path id="패스_1018" data-name="패스 1018" d="M17.286,5V25l-7.143-5.714H3V10.714h7.143Z" transform="translate(0 0)" fill="#7260ff" stroke="#7260ff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
          <path id="패스_1019" data-name="패스 1019" d="M13,15.714a3.52,3.52,0,0,0,1.58-3.277A3.31,3.31,0,0,0,13,10" transform="translate(4.286 2.143)" fill="none" stroke="#7260ff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
        </g>
      </g>
    </svg>
  </div>
</template>
<script>
export default {
    props:{
        mute:Boolean
    }    
}
</script>

